import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

const selectRootState = (state: RootState) => state.auth;

export const selectIsLoggedIn = createSelector(selectRootState, (state) => state.isLoggedIn);
export const selectUserProfile = createSelector(selectRootState, (state) => state.userProfile);
